module.exports = __webpack_public_path__ + "public/SiteIcons/createWishListIcon.svg?e5916124";